import useNavPoint from "@hooks/useNavPoint";
import React, { useEffect, useMemo } from "react";
import ModalBody from "../../../app/_components/ModalBody";
import KitNav from "./KitNav";
import useModals, { ModalTypes } from "@actions/useModals";

const KitNavModal = () => {
  const navPoint = useNavPoint();
  const { dismissModal } = useModals();

  // To dismiss the modal when the navPoint changes
  // We get the initial location hash on mount
  // If the location changes, we dismiss the modal
  const locationHash = [navPoint.sectionId, navPoint.version, navPoint.kitId].join("|");
  const startLocation = useMemo(
    () => locationHash,
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  );
  useEffect(() => {
    if (locationHash !== startLocation) dismissModal(ModalTypes.KIT_NAVIGATION);
  }, [dismissModal, locationHash, startLocation]);

  if (!navPoint.kit) return null;

  return (
    <ModalBody>
      <KitNav
        space={navPoint.space}
        portal={navPoint.portal}
        kit={navPoint.kit}
        sectionId={navPoint.sectionId}
        kitVersion={navPoint.kitVersion}
      />
    </ModalBody>
  );
};

export default KitNavModal;
